import { render } from "./GoLike.vue?vue&type=template&id=36d7619e&scoped=true"
import script from "./GoLike.vue?vue&type=script&lang=js"
export * from "./GoLike.vue?vue&type=script&lang=js"

import "./GoLike.vue?vue&type=style&index=0&id=36d7619e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d7619e"]])

export default __exports__